import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

require('@/assets/scss/common.scss');

Vue.config.productionTip = false;

router.afterEach(to => {
  gtag('config', 'UA-16899956-9', { page_path: to.path });
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
